(function() {
    'use strict';

    angular
        .module('elogbooks')
        .config(Translations);

    function Translations($translateProvider) {
        $translateProvider.translations('en-gb', {
            LINKED: 'Linked',
            LINKED_TO_SSO: 'Linked to SSO',
            LINK_TO_SSO: 'Link to SSO',
            LINK_TO_SSO_SUCCESSFUL: 'Account Linked to Auth0 Successfully',
            LINK_ACCOUNT_TEXT: 'You must login to your Auth0 account.',
            SSO_USERS: 'SSO Users',
            SSO_USERS_LIST: 'SSO Users List',
            SSO_AUTHORISE_FAILED: 'SSO Authorise Failed',
            SSO_LINK_CHECK_FAILED: 'SSO Link check failed',
            SSO_LOGIN_FAILED: 'SSO Login Failed',
            INVALID_ACCESS_TOKEN: 'Invalid SSO Access token. Please try again.',
            INVALID_LOGIN_RESPONSE: 'Invalid Login Response',
            NO_USER_DATA: 'No User Data',
            DOMAIN: 'Domain',
            // USER_MISMATCH means the authenticated SSO identity is linked to a
            // different CAFM account than the username entered — in practice, a
            // non-matching Microsoft session. Naming the cause is what makes it
            // actionable (the user can switch account in the Microsoft picker),
            // and it stays enumeration-safe because it identifies neither
            // account: it never echoes the SSO email, and it's the same text
            // shown for every SSO_CANNOT_LINK_ACCOUNT sub-case, so it can't be
            // used to tell an existing username from a non-existent one.
            USER_MISMATCH: 'The selected Microsoft Account email address does not match the email address for the provided User account details, please try again.',
            USER_NOT_LINKED_MICROSOFT: 'Account is not linked yet. Please log in through normal login process to link it with your Microsoft account.',
            USER_AUTH_SSO_LOGIN_REQUIRED: 'SSO Login Required.',
            SSO_CONFIGURATION_UNAVAILABLE: 'Single sign-on is unavailable at the moment. Please reload the page, or contact the Vantify CAFM Helpdesk if the problem continues.',
            SSO_NEXT_HINT_UNAVAILABLE: 'We couldn\'t check how to sign you in. Please try again, or contact the Vantify CAFM Helpdesk if the problem continues.',
            SSO_LINK_PASSWORD_INTRO: 'To finish linking your account, please confirm your password.',
            SSO_LINK_PASSWORD_LABEL: 'Password',
            SSO_LINK_TOO_MANY_ATTEMPTS: 'Account Locked.',
            SSO_LINK_SUBMIT: 'Link Account',
            SSO_LINK_CANCEL: 'Cancel and return to login',
            SSO_LINK_SYSTEM_ERROR: 'Something went wrong. Please try again.',
            SSO_LINK_FORGOT_PASSWORD: 'Forgotten your password?',
            SSO_LINK_RESET_PASSWORD_EXPLANATION: 'We\'ll email you a link to reset your password.',
            SSO_AUTH_REDIRECT_ERROR: 'We couldn\'t sign you in through SSO. Please try again or contact the Vantify CAFM Helpdesk if the problem continues.',
            SSO_EMAIL_NOT_UNIQUE: 'The email address on your SSO account is already in use by another active account, so we can\'t link it. Please contact the Vantify CAFM Helpdesk to resolve this.',
            // The backend rejected the link for one of several identity checks
            // (no matching account, email or domain mismatch, already linked).
            // Worded for the dominant case — an email mismatch on a first-time
            // link — but kept identical across every sub-case, so it still
            // discloses nothing about which check failed or whether the username
            // exists. Deliberately doesn't imply the password was wrong;
            // retrying it won't help.
            SSO_CANNOT_LINK_ACCOUNT: 'The selected Microsoft Account email address does not match the email address for the provided User account details, please try again.',
            CLP_HANDOFF_SIGNING_IN: 'Signing you in\u2026',
            // Reason-free on purpose: naming it would allow account probing.
            CLP_HANDOFF_PASSWORD_REQUIRED: 'We couldn\'t sign you in automatically. Please enter your password to continue.'
        });
    }
})();
